
import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { cellGreenIfHasValue, getterTime, renderCellTime, renderCellTimeWithFileDrop } from "branch/pages/ShippingProcess/columns"
import { shippingInvoiceColNm } from "branch/pages/ShippingProcess/constant"
import { BoxFR } from "components/BoxCustom"
import dayjs from "dayjs"
import {  ReplyRounded } from "resource/muiImport"
import { shippingColumnsEnd } from "./shippingColumnsEnd"
import { shippingColumnsStart } from "./shippingColumnsStart"


// ------------------------------------------------------------------------------------------------------------------
// ------------------------------------------------------Import Columns------------------------------------------------------
// ------------------------------------------------------------------------------------------------------------------
export const shippingProcessImportColumns = ({ handleFileClick, handlePrintDriver, handleUpdateTime
  , handleDeleteTime, onFileUploadSuccess, handlePrintExpense, handleUpdateETA }) => [
  ...shippingColumnsStart({ handleUpdateETA }),
  {
    field: 'SealContTm',
    cellClassName: cellGreenIfHasValue,
    headerName: shippingInvoiceColNm.SealContTm,
    width: 80,
    type: 'date',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM") : "-",
  },
  {
    field: 'BLRecvTm',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.BLRecvTm,
    width: 170,
    type: 'dateTime',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => renderCellTime(params, handleUpdateTime, handleDeleteTime)
  },
  // {
  //   field: 'BLCfTm',
  //   cellClassName: "normal-col",
  //   headerName: shippingInvoiceColNm.BLCfTm,
  //   width: 170,
  //   type: 'dateTime',
  //   editable: true,
  //   valueGetter: getterTime,
  //   valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  //   renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess)
  // },
  // {
  //   field: 'BLSndTm',
  //   cellClassName: "normal-col",
  //   headerName: shippingInvoiceColNm.BLSndTm,
  //   width: 170,
  //   type: 'dateTime',
  //   editable: true,
  //   valueGetter: getterTime,
  //   valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  //   renderCell: (params) => renderCellTime(params, handleUpdateTime, handleDeleteTime)
  // },
  {
    field: 'ANRecvTm',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.ANRecvTm,
    width: 170,
    type: 'dateTime',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess)
  },
  // {
  //   field: 'MBLRecvTm',
  //   cellClassName: "normal-col",
  //   headerName: shippingInvoiceColNm.MBLRecvTm,
  //   width: 170,
  //   type: 'dateTime',
  //   editable: true,
  //   valueGetter: getterTime,
  //   valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  //   renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess)
  // },
  {
    field: 'MBLEntrTm',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.MBLEntrTm,
    width: 170,
    type: 'dateTime',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => renderCellTime(params, handleUpdateTime, handleDeleteTime)
  },
  {
    field: 'FrtInvTm',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.FrtInvTm,
    width: 170,
    type: 'dateTime',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 10)
  },
  {
    field: 'FrtInvPaidTm',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.FrtInvPaidTm,
    width: 170,
    type: 'dateTime',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 10)
  },
  // {
  //   field: 'DOMailTm',
  //   cellClassName: "normal-col",
  //   headerName: shippingInvoiceColNm.DOMailTm,
  //   width: 170,
  //   type: 'dateTime',
  //   editable: true,
  //   valueGetter: getterTime,
  //   valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  //   renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 10)
  // },
  {
    field: 'DORecvTm',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.DORecvTm,
    width: 170,
    type: 'dateTime',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 10)
  },
  {
    field: 'TakePlc',
    headerName: shippingInvoiceColNm.TakePlc,
    width: 80,
    cellClassName: ({ value }) => value ? "green-progress" : ""
  },
  // {
  //   field: 'CstmFormDfTm',
  //   cellClassName: "normal-col",
  //   headerName: shippingInvoiceColNm.CstmFormDfTm,
  //   width: 170,
  //   type: 'dateTime',
  //   editable: true,
  //   valueGetter: getterTime,
  //   valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  //   renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 14)
  // },
  {
    field: 'CstmFormCfTm',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.CstmFormCfTm,
    width: 170,
    type: 'dateTime',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => renderCellTime(params, handleUpdateTime, handleDeleteTime)
  },
  {
    field: 'CstmClrTm',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.CstmClrTm,
    width: 170,
    type: 'dateTime',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => renderCellTime(params, handleUpdateTime, handleDeleteTime)
  },
  {
    field: 'AptTm',
    cellClassName: "normal-col",
    headerName: 'วันที่นัดเข้า รง.',
    width: 120,
    type: 'dateTime',
    valueGetter: getterTime,
    // valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => {
      return (
        <BoxFR sx={{ width: "100%", gap: 0 }}>
          <Typography variant='body2' >{params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-"}</Typography>
          <Box flexGrow={1} />
          <Tooltip title="ไปที่หน้า 1.3" placement='top' followCursor>
            <IconButton sx={{ p: 0, m: 0 }} onClick={() => {
              var win = window.open(window.location.origin + `/emily/DailyJob/ShpmId/${params.row.ShpmId}`, '_blank');
              win.focus();
            }}>
              <ReplyRounded sx={{ transform: "scaleX(-1)" }} />
            </IconButton>
          </Tooltip>
        </BoxFR>
      )
    }
  },
  ...shippingColumnsEnd({ handleFileClick, handlePrintDriver, handleUpdateTime
  , handleDeleteTime, onFileUploadSuccess, handlePrintExpense })
]